import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { c_dialog_upgrade_bulk_dealer_plan_for_site_plan_component } from './c_dialog_upgrade_bulk_dealer_plan_for_site_plan_component';

@NgModule({
  imports: [CommonModule, FormsModule],
  declarations: [c_dialog_upgrade_bulk_dealer_plan_for_site_plan_component],
})
export class c_dialog_upgrade_bulk_dealer_plan_for_site_plan_module { }
